import React from 'react';
import { ColorPicker } from 'antd';
import type { ColorPickerProps } from 'antd';

type ColorFormat = NonNullable<ColorPickerProps['format']>;

export const HexColorPicker: React.FC<ColorPickerProps> = ({
  showText = true,
  format,
  onFormatChange,
  ...props
}) => {
  const isControlled = format !== undefined;
  const [innerFormat, setInnerFormat] = React.useState<ColorFormat>(format ?? 'hex');
  const mergedFormat = (isControlled ? format : innerFormat) ?? 'hex';

  const handleFormatChange = React.useCallback(
    (nextFormat?: ColorFormat) => {
      if (!isControlled && nextFormat) {
        setInnerFormat(nextFormat);
      }
      onFormatChange?.(nextFormat);
    },
    [isControlled, onFormatChange]
  );

  return (
    <ColorPicker
      {...props}
      showText={showText}
      format={mergedFormat}
      onFormatChange={handleFormatChange}
      disabledAlpha
    />
  );
};
